var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"rounded white pa-0",attrs:{"id":"integration-marketplace-placeholder","elevation":"2","height":"696"}})
}
var staticRenderFns = []

export { render, staticRenderFns }